import React, { useEffect, useState } from "react";
import Navbar from "../common/navbar/Navbar";
import Footer from "../common/footer/Footer";
import { Outlet } from "react-router-dom";
import BottomButton from "../common/bottomButton/BottomButton";
import SocialIcons from "../common/SocialIcons";

const Layout = () => {
  const [isButtonInFooter, setIsButtonInFooter] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const button = document.getElementById("your-button-id");
      const footer = document.getElementById("your-footer-id");

      if (button && footer) {
        const buttonRect = button.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        const buttonInFooter = buttonRect.bottom > footerRect.top;

        setIsButtonInFooter(buttonInFooter);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const buttonStyle = {
    backgroundColor: isButtonInFooter ? "#fff0f0" : "",
    Color: isButtonInFooter ? "#A5302E" : "#fff",
    border: isButtonInFooter ? "1px solid #fff" : "",
  };

  return (
    <div className="relative top-0">
      <Navbar />
      <Outlet />
      <BottomButton id={"your-button-id"} buttonStyle={buttonStyle} />
      <Footer id={"your-footer-id"} />
      <SocialIcons />
    </div>
  );
};

export default Layout;
